import React from "react";
import CorrectIcon from "../../resources/icons/correct-live-double.svg";

const ProgressStepper = ({ steps, currentStep }) => {
  return (
    <div id="progress-stepper-container" className="flex justify-between w-full mb-[1.1rem] bg-[#f5f5f5a2] p-4 rounded">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <div id={`progress-stepper-step-${index}`} className="flex flex-col items-center">
            <div
              className={`rounded-full w-10 h-10 flex items-center justify-center ${
                index < currentStep
                  ? "bg-green-500"
                  : index === currentStep
                  ? "bg-cfPrimaryLight"
                  : "bg-gray-300"
              }`}
            >
              {index < currentStep ? (
                <img src={CorrectIcon} height={20} width={20} alt="" />
              ) : (
                <svg
                  className="w-6 h-6 text-white"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <circle cx="12" cy="12" r="10" />
                </svg>
              )}
            </div>
            <span id={`progress-stepper-step-${index}-label`} className="text-sm mt-2 text-black">{step}</span>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`flex-1 h-[2px] ${
                index < currentStep
                  ? "bg-green-500 mt-[1.3rem]"
                  : "bg-gray-300 mt-[1.3rem]"
              }`}
            ></div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressStepper;
